const FILTER_KEYS = {
    ruleType: "ruleType",
    startDay: "startDay",
    endDay: "endDay",
    minNightsLimit: "minNightsLimit",
    minPeopleLimit: "minPeopleLimit",
    maxPeopleLimit: "maxPeopleLimit",
    maxPetsLimit: "maxPetsLimit",
    totalFilteredRequests: "totalFilteredRequests",
    totalFilteredRequestsNotOld: "totalFilteredRequestsNotOld"
};
export default FILTER_KEYS